import CreateHttpClient from './createTimetablesWebApiHttpClient';
import { AxiosInstance } from 'axios';

import { Account } from '../models/account';

class AccountApi {
    private httpClient: AxiosInstance;

    constructor() {
        this.httpClient = CreateHttpClient();
    }

    async GetAllAccounts() {
        const { data } = await this.httpClient.get(`/account`);
        return data;
    }

    async GetAccountTypes() {
        const { data } = await this.httpClient.get(`/account/types`);
        return data;
    }

    async AddNewAccount(account: Account) {
        const { data } = await this.httpClient.post(`/account`, account);
        return data;
    }

    async UpdateAccount(account: Account) {
        const payload = {
            ...account,
        };
        const { data } = await this.httpClient.put(`/account`, payload);
        return data;
    }
}

export default AccountApi;
